import { render, staticRenderFns } from "./SplashAd.vue?vue&type=template&id=10e22a88&scoped=true&"
import script from "./SplashAd.vue?vue&type=script&lang=js&"
export * from "./SplashAd.vue?vue&type=script&lang=js&"
import style0 from "./SplashAd.vue?vue&type=style&index=0&id=10e22a88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e22a88",
  null
  
)

export default component.exports